import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom'
import Cookies from 'js-cookie'
import { CircularProgress, createMuiTheme, ThemeProvider } from '@material-ui/core'
import LandingPage from './components/login/LandingPage'
import Nav from './components/layout/Navbar'
import Home from './components/home/Home'
import CalendarPort from './components/calendarPort/CalendarPort'
import Boomerang from './components/boomerang/Boom'
import BoomLostOpp from './components/boomerang/BoomerangLostOpp'
import Triggers from './components/triggers/Triggers'
import RoiMain from './components/roi/RoiMain'
import EventMarketing from './components/eventMarketing/EventMarketingMain'
import ProductPerformance from './components/prodPerformance/ProductPerformance'
import ProdPerformance from './components/prodPerformance/ProdPerformance'
import RfmCounts from './components/rfm/RfmCounts'
import Rfm from './components/rfm/Rfm'
import OtbCounts from './components/otb/OtbCounts'
import CustRet from './components/customerRetention/CustRet'
import CustRetention from './components/customerRetention/CustomerRetention'
import Demographics from './components/demographics/Demographics'
import DemoByLoc from './components/demographics/DemoByLoc'
import CprStats from './components/cpr/CprStats'
import ZipCode from './components/zipcode/Zipcode'
import DemoTrends from './components/demographics/DemoTrends'
import AddSalesPerson from './components/salesPersons/AddSalesPerson'
import EditSalesPerson from './components/salesPersons/EditSalesPerson'
import SalesPersonDirectory from './components/salesPersons/SalesPersonDirectory'
import TableauPort from './components/TableauPort'
import './assets/styles.css'

const PrivateRoute = ({ component: Component, ...rest}) => {
  return (
    <Route
      {...rest}
      render={props => (
        Cookies.get('token')
        ? <Component {...props} />
        : <Redirect to="/login" />
      )}
    />
  )
}
export default function App() {  
  const [status, setStatus] = useState(null)
  const [currentUser, setCurrentUser] = useState(null)
  const [darkTheme, setDarkTheme] = useState(JSON.parse(localStorage.getItem("darkMode")) !== null ? JSON.parse(localStorage.getItem("darkMode")) : true)
  const [token, setToken] = useState(null)

  const setUser = (token) => {
    const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/user`, {
    // const request = fetch('https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/user', {
      headers: {
        token: token
      }
    })

    request
    .then(response => response.json())
    .then(data => {
      setCurrentUser(data)
      localStorage.setItem('currentUser', JSON.stringify(data))
      localStorage.setItem("tableauScreens", JSON.stringify(data[0].tableau))
    })
    .catch(error => console.log(error))
  }

  const handleLogin = (data) => {
    setToken(data)
    setStatus('logged-in')

    Cookies.set('token', data, {expires: 1}, {secure: true})

    setUser(Cookies.get('token'))
  }

  // const handleLogin = (data) => {
  //   setToken(data)
  //   setStatus('logged-in')
  //
  //   Cookies.set('token', data.TOKEN, {expires: 1}, {secure: true})
  //
  //   getUserData(Cookies.get('token'))
  // }

  const handleLogout = () => {
    fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/logout`, {
      method: 'DELETE',
      headers: {
        'token': Cookies.get('token')
      }
    })
    .then(response => {
      if(response.ok === true) {
        return response
      }
    })

    setStatus('logged-out')
    setCurrentUser(null)
    setToken(null)
    Cookies.remove('token')
    localStorage.removeItem('currentUser')
    localStorage.removeItem("tableauScreens")
    localStorage.removeItem('accounts')
  }

  // const theme = createMuiTheme({
  //   palette: {
  //     type: 'dark'
  //   }
  // })

  const handleDarkTheme = (darkMode) => {    
    setDarkTheme(!darkTheme)

    localStorage.setItem("darkMode", !darkTheme)
  }

  const tableauRoutes = localStorage.getItem("tableauScreens")

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f4f4f4",
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
    padding: "20px",
  };

  const boxStyle = {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    maxWidth: "500px",
    width: "100%",
  };

  const titleStyle = {
    fontSize: "2rem",
    marginBottom: "10px",
    color: "#333",
  };

  const messageStyle = {
    fontSize: "1rem",
    marginBottom: "20px",
    color: "#666",
    lineHeight: "1.5",
  };


  return (

    <div className={darkTheme ? "smartdash-app" : "smartdash-app-light"}>     
    <Router>
      <Switch>
        <Route exact path={"/login"} render={props => (
          <LandingPage {...props} handleSuccess={handleLogin} handleLogout={handleLogout}/>
        )} />
        <Nav
          handleLogout={handleLogout}
          handleDarkThemeToggle={handleDarkTheme}
          user={currentUser}
          dark={darkTheme}
        >
          <PrivateRoute exact path={"/"} component={() => <Home status={status} currentUser={currentUser} dark={darkTheme}/>}/>
          <PrivateRoute exact path={"/calendar"} component={() => <CalendarPort />} />
          <PrivateRoute exact path={"/boomerang"} component={() => <RoiMain status={status} currentUser={currentUser} pageName={"Boomerang"} />}/>
          <PrivateRoute exact path={"/boomerang/lost-opportunity"} component={() => <BoomLostOpp status={status} currentUser={currentUser} />}/>
          <PrivateRoute exact path={"/triggers"} component={() => <RoiMain status={status} currentUser={currentUser} pageName={"Triggers"} />}/>
          <PrivateRoute exact path={"/event-marketing"} component={() => <EventMarketing status={status} currentUser={currentUser} dark={JSON.parse(localStorage.getItem("darkMode")) !== null ? JSON.parse(localStorage.getItem("darkMode")) : true}/>}/>
          <PrivateRoute exact path={"/product-performance"} component={() => <ProdPerformance status={status} currentUser={currentUser} dark={darkTheme}/>}/>
          <PrivateRoute exact path={"/rfm-counts"} component={() => <Rfm status={status} currentUser={currentUser} dark={darkTheme}/>}/>
          <PrivateRoute exact path={"/otb-counts"} component={() => <OtbCounts status={status} currentUser={currentUser} dark={darkTheme}/>}/>

          <PrivateRoute exact path={"/customer-retention"} component={() => <CustRetention status={status} currentUser={currentUser} dark={darkTheme}/>}/>          
          <PrivateRoute exact path={"/cpr-stats"} component={() => <CprStats dark={darkTheme}/>} />
          <PrivateRoute exact path={"/demographics"} component={() => <DemoByLoc dark={darkTheme}/>} />
          <PrivateRoute exact path={"/zip-code"} component={() => <ZipCode />} />
          <PrivateRoute exact path={"/demographic-trends"} component={() => <DemoTrends />} />


          <PrivateRoute exact path={"/sales-consultants"} component={() => <SalesPersonDirectory status={status} currentUser={currentUser} />}/>
          <PrivateRoute exact path={"/sales-consultants-add"} component={() => <AddSalesPerson status={status} currentUser={currentUser} />}/>
          <PrivateRoute path={"/sales-consultants/:id"} component={() => <EditSalesPerson status={status} currentUser={currentUser} />}/>

          {tableauRoutes ?
            JSON.parse(tableauRoutes).map(({ID, display, short_name, beta}) => (
              <PrivateRoute 
                key={ID}
                exact
                path={`/${display}`}
                pageName={short_name}
                component={() => <TableauPort betaFlag={beta} viz={display} pageName={short_name}/>}
              />
            )) : null
          }         
        </Nav>
      </Switch>
    </Router>
  </div>
  )
}
